<template>
    <div class="technology technology_reveal">
        <h1 class="title technology_title_reveal">Back-End</h1>
        <div class="container technology_languages_reveal">
            <div class="technology-box">
                <img src="../../../assets/img/languages/php.svg" class="language" alt="PHP" title="PHP" />
            </div>
            <div class="technology-box">
                <img src="../../../assets/img/languages/laravel.svg" class="language" alt="Laravel" title="Laravel" />
            </div>
            <div class="technology-box">
                <img src="../../../assets/img/languages/nodejs.svg" class="language" alt="Node.js" title="Node.js" />
            </div>
            <div class="technology-box">
                <img src="../../../assets/img/languages/ts.svg" class="language" alt="TypeScript" title="TypeScript" />
            </div>
            <div class="technology-box">
                <img src="../../../assets/img/languages/graphql.svg" class="language" alt="GraphQL" title="GraphQL" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TechnologyBackEnd',
};
</script>
